module.exports = __webpack_public_path__ + "img/notice.de31d4e3.svg";